import { getOs, type OperatingSystem } from 'owa-user-agent';
import { isDocumentVisible } from 'owa-analytics-utils/lib/visibilityState';

export const isIOSBackgroundCall = () => {
    return getOs() === 'iOS' && !isDocumentVisible();
};
